import { render, staticRenderFns } from "./Return_details_new.vue?vue&type=template&id=c6d5aede&scoped=true&"
import script from "./Return_details_new.vue?vue&type=script&lang=js&"
export * from "./Return_details_new.vue?vue&type=script&lang=js&"
import style0 from "./Return_details_new.vue?vue&type=style&index=0&id=c6d5aede&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d5aede",
  null
  
)

export default component.exports